import { EVENT_TYPE_NAMES } from '../../common/analytics/amplitudeEventTypesUtil';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../common/analytics/statsConstants';
import { sendAmplitudeEvent } from './amplitudeService';

export enum NoteInsertionType {
    BOARD_LINK = 'boardLink',
    DIVIDER = 'divider',
    COMMENT = 'comment',
    MENTION = 'mention',
    EMOJI = 'emoji',
}

export enum NoteInsertionSource {
    PASTE = 'paste',
    INLINE = 'inline',
    TOOLBAR = 'toolbar',
    INSERT_MENU = 'insertMenu',
}

const noteInsertionUserProperties = {
    [AMPLITUDE_USER_PROPS.FEATURE]: { [TRACKED_FEATURES.NOTE_INSERTION]: true },
};

export const trackNoteInsertionEvent = (insertionType: NoteInsertionType, source: NoteInsertionSource): void => {
    sendAmplitudeEvent({
        eventType: EVENT_TYPE_NAMES.NOTE_INSERT,
        eventProperties: {
            insertionType,
            source,
        },
        userProperties: noteInsertionUserProperties,
    });
};
